// extracted by mini-css-extract-plugin
export var cardTitle = "_ik-1";
export var commentBubble = "_ik-e";
export var commentForm = "_ik-a";
export var commentInput = "_ik-b";
export var commentLabel = "_ik-d";
export var commentPrompt = "_ik-9";
export var csatCard = "_ik-0";
export var feedbackSection = "_ik-7";
export var starDisabled = "_ik-6";
export var starEmpty = "_ik-5";
export var starFilled = "_ik-4";
export var starWrapper = "_ik-3";
export var starsContainer = "_ik-2";
export var submittedComment = "_ik-c";
export var thankYouText = "_ik-8";